const despatchList = [
  {
    key: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    recordCount: 0,
    uuid: "string",
    despatchId: "string",
    despatchNo: "string",
    receiverTaxId: "string",
    receiverAllias: "string",
    receiverPartyName: "string",
    despatchDate: "2023-08-07T13:49:11.703Z",
    despatchTime: "2023-08-07T13:49:11.703Z",
    status: "string"
  },
  {
    despatchId: "SFN2022000000002",
    receiverTaxId: "1234567891",
    receiverAllias: "Muzolas",
    receiverPartyName: "Muzo",
    despatchDate: "01-01-2020",
    despatchTime: "01-01-2020",
    status: "Bekliyor",
    uuid: "1234", 
    key: "2",
  }
  ,
  {
    despatchId: "SFN2022000000003",
    receiverTaxId: "1234567892",
    receiverAllias: "Memolas",
    receiverPartyName: "Memo",
    despatchDate: "01-01-2020",
    despatchTime: "01-01-2020",
    status: "Bekliyor",
    uuid: "12345", 
    key: "3",
  }
  ,
  {
    despatchId: "SFN2022000000001",
    receiverTaxId: "1234567890",
    receiverAllias: "Özgürolas",
    receiverPartyName: "Özgür",
    despatchDate: "01-01-2020",
    despatchTime: "01-01-2020",
    status: "Bekliyor",
    uuid: "123456", 
    key: "4",
  }
];
export default despatchList;
